import React from 'react';
import DeviationDuperbrowseContext from '../../../Duperbrowse/DeviationDuperbrowseContext';
import { BiLoggerContextProvider } from '../../../biLogger';
import SidebarBlock from '../SidebarBlock';
import ThumbWithLoader from '../ThumbWithLoader';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import s from './JournalGridBlock.scss';
var thumbHeight = s["sidebar-thumb-height-journal"];
export var JournalGridBlock = function (_a) {
    var _b = _a.journals, journals = _b === void 0 ? [] : _b, streamKey = _a.streamKey, titleOverride = _a.titleOverride, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.maxLength, maxLength = _d === void 0 ? 3 : _d, parentDeviation = _a.parentDeviation;
    if (!isLoading && !journals.length) {
        return null;
    }
    var slice = isLoading
        ? Array(maxLength).fill(undefined)
        : journals.slice(0, maxLength);
    return (React.createElement(SidebarBlock, { streamKey: streamKey, titleOverride: titleOverride, isLoading: isLoading },
        React.createElement(DeviationDuperbrowseContext, { streamId: "deviation-sidebar-" + streamKey, deviations: journals, parent: {
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId,
            } }, slice.map(function (deviation, index) { return (React.createElement(BiLoggerContextProvider, { key: index, value: { _rankIndex: index } },
            React.createElement(ThumbWithLoader, { deviation: deviation, isLoading: isLoading, className: s['journal'], height: parseInt(thumbHeight, 10) }))); }))));
};
JournalGridBlock.displayName = 'JournalGridBlock';
export default JournalGridBlock;
//# sourceMappingURL=JournalGridBlock.js.map